import { billingDetailsToApi, toBillingDetails } from './mapBilling';
import {
  BillingDetails as ApiBillingDetails,
  GenerateInvoicesResponse as ApiGenerateInvoicesResponse,
  Invoice as ApiInvoice,
  InvoiceListResponse as ApiInvoiceListResponse,
  InvoiceTransaction as ApiInvoiceTransaction,
  InvoiceTransactionListResponse as ApiInvoiceTransactionListResponse,
  ProcessInvoiceTransactionsResponse as ApiProcessInvoiceTransactionsResponse,
  UpdateInvoiceRequest as ApiUpdateInvoiceRequest,
} from '@/gen/api';
import {
  GeneratedInvoices,
  Invoice,
  Invoices,
  InvoiceTransaction,
  InvoiceTransactions,
  InvoiceUpdate,
  ProcessedInvoiceTransactions,
} from '@/models/Invoice';

const toApiBillingDetails = (
  billingDetails: InvoiceUpdate['billingDetails'],
): ApiBillingDetails | undefined => {
  return billingDetails ? billingDetailsToApi(billingDetails) : undefined;
};

export const toInvoice = (invoice: ApiInvoice): Invoice => {
  return {
    ...invoice,
    billingDetails: toBillingDetails(invoice.billingDetails),
  };
};

export const toInvoices = (response: ApiInvoiceListResponse): Invoices => {
  return {
    totalCount: response.totalCount,
    estimatedTotalCount: response.estimatedTotalCount,
    items: response.items.map(toInvoice),
  };
};

export const toInvoiceTransaction = (
  invoiceTransaction: ApiInvoiceTransaction,
): InvoiceTransaction => {
  return {
    ...invoiceTransaction,
  };
};

export const toInvoiceTransactions = (
  response: ApiInvoiceTransactionListResponse,
): InvoiceTransactions => {
  return {
    totalCount: response.totalCount,
    estimatedTotalCount: response.estimatedTotalCount,
    items: response.items.map(toInvoiceTransaction),
  };
};

export const invoiceUpdateToApi = (invoice: InvoiceUpdate): ApiUpdateInvoiceRequest => {
  return {
    ...invoice,
    billingDetails: toApiBillingDetails(invoice.billingDetails),
  };
};

export const toGeneratedInvoices = (response: ApiGenerateInvoicesResponse): GeneratedInvoices => {
  return {
    generated: response.generated,
  };
};

export const toProcessedInvoiceTransactions = (
  response: ApiProcessInvoiceTransactionsResponse,
): ProcessedInvoiceTransactions => {
  return {
    totalCount: response.totalCount,
    estimatedTotalCount: response.estimatedTotalCount,
    processed: response.processed,
  };
};
